import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import NoAccessMessage from './NoAccessMessage';

const MenuListing = ({ filteredFeatures, from, user, ...props }) => {
  const { pathname } = useLocation();
  
  const getIcon = (item) => {
    const iconSize = from === 'dashboardNavigation' ? 20 : 25;
    return (
      <img
        style={{borderRadius: '50%'}}
        src={item?.icon}
        alt={item.feature_name}
        width={iconSize}
        height={iconSize}
        className={`menu-item__icon ${from === 'dashboardNavigation' ? 'menu-item__icon--dashboard' : 'menu-item__icon--default'}`}
      />
    );
  };

  const isSelected = (item) => {
    const selectedTabPath = props.selectedTabPath;
    return selectedTabPath ? item.route === selectedTabPath : pathname === item.route;
  };

  const isExternalRoute = (item) => {
    return item?.route?.includes('/v2') || item?.route?.includes('/v3') || item?.route?.includes('/valmo');
  };

  const getClassName = (baseClass, isSelected) => {
    return `${baseClass} pointer ${isSelected ? `${baseClass}--selected` : `${baseClass}--unselected`}`;
  };

  const renderMenuItem = (item) => {
    const itemIsSelected = isSelected(item);
    const itemIsExternal = isExternalRoute(item);
    const icon = getIcon(item);

    // Common content for both dashboard and card views
    const renderContent = (LinkComponent, linkProps) => (
      <LinkComponent {...linkProps}>
        {from === 'dashboardNavigation' ? (
          <>
            {icon}
            <div className={`menu-item__feature-name ${itemIsSelected ? 'menu-item__feature-name--selected' : 'menu-item__feature-name--unselected'}`}>
              {item.feature_name}
            </div>
          </>
        ) : (
          <>
            <div className="menu-card__icon-container">
              {icon}
            </div>
            <div className={`menu-card__content ${itemIsSelected ? 'menu-card__content--selected' : 'menu-card__content--unselected'}`}>
              <h3 className="menu-card__title">
                {item.feature_name}
              </h3>
            </div>
          </>
        )}
      </LinkComponent>
    );

    if (from === 'dashboardNavigation') {
      const LinkComponent = itemIsExternal ? 'a' : Link;
      const linkProps = itemIsExternal 
        ? { href: item.route, className: `menu-item__link ${itemIsSelected ? 'menu-item__link--selected' : 'menu-item__link--unselected'}` }
        : { to: item?.route, className: `menu-item__link flex ${itemIsSelected ? 'menu-item__link--selected' : 'menu-item__link--unselected'}` };

      return (
        <li
          key={item.id}
          className={getClassName('menu-item', itemIsSelected)}
        >
          {renderContent(LinkComponent, linkProps)}
        </li>
      );
    } else {
      const LinkComponent = itemIsExternal ? 'a' : Link;
      const linkProps = itemIsExternal 
        ? { href: item.route, className: `menu-card__link ${itemIsSelected ? 'menu-card__link--selected' : 'menu-card__link--unselected'}` }
        : { to: item?.route, className: `menu-card__link ${itemIsSelected ? 'menu-card__link--selected' : 'menu-card__link--unselected'}` };

      return (
        <div
          key={item.id}
          className={getClassName('menu-card', itemIsSelected)}
        >
          {renderContent(LinkComponent, linkProps)}
        </div>
      );
    }
  };

  return (
    <div className={from === 'dashboardNavigation' ? 'menu-items-list' : 'menu-cards-container'}>
      {filteredFeatures?.length > 0 && user?.roles?.length > 0 ? (
        from === 'dashboardNavigation' ? (
          <ul>{filteredFeatures?.map(renderMenuItem)}</ul>
        ) : (
          <div className="menu-cards-grid">
            {filteredFeatures?.map(renderMenuItem)}
          </div>
        )
      ) : (
        <>
          {filteredFeatures?.length === 0 && <div className="no-features-found">No features found matching your search criteria</div>}
          {user?.roles?.length === 0 && <NoAccessMessage roles={user?.roles}/>}
        </>
      )}
    </div>
  );
};

export default MenuListing;
